export const isAuthenticated = (state) => state.auth.token && state.user.user;
